import { Component, OnInit } from "@angular/core";
import { FieldType } from "@kre-form/core";
import { KreFormAntService } from "../tools/service";

@Component({
  selector: "krefield-textarea",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <textarea
          nz-input
          disabled
          [rows]="to.rows ? to.rows : 4"
          style="resize:none"
        >
        </textarea>
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <textarea
          wrap="hard"
          nz-input
          autocomplete="off"
          [formControl]="formControl"
          class="form-control"
          [class.is-invalid]="showError"
          [kreFormAttributes]="field"
          [rows]="to.rows ? to.rows : 4"
          style="resize:none"
          [maxLength]="to.maxLength || 500"
          [minLength]="to.minLength || 0"
        >
        </textarea>
        <!-- <div class="tips">
          <i
            class="icon-bangzhu"
            [nzTooltipTitle]="tips"
            nzTooltipPlacement="top"
            nz-tooltip
            *ngIf="tips != ''"
          ></i>
        </div> -->
      </ng-container>
      <div
        class="fieldtext krefield-textarea-{{ to.rows || 4 }} "
        *ngIf="editor === false"
        [innerHTML]="text | replaceLine"
      ></div>
    </ng-template>
  `,
})
export class KreFormFieldTextArea extends FieldType implements OnInit {
  ngOnInit(): void {
    // console.log(this.formControl.value);
  }
}
